export default {
    lang: {
        name: 'Community minimum age'
    }
}